// extracted by mini-css-extract-plugin
export default {"productList":"product_cadastre_list_productList__n794y","Mui-focused":"product_cadastre_list_Mui-focused__8yRim","label":"product_cadastre_list_label__A0py1"};